module.exports = __webpack_public_path__ + "img/src/assets/img_new/projectsSlider/serdce-poster.jpg";